/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free word and character counter. Count words, characters, sentences and paragraphs, with reading time and keyword density. Works as you type.`)
};

const es_wc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador gratuito de palabras y caracteres. Cuenta palabras, caracteres, oraciones y párrafos, con tiempo de lectura y densidad de palabras clave. Funciona mientras escribes.`)
};

const de_wc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Wort- und Zeichenzähler. Zählen Sie Wörter, Zeichen, Sätze und Absätze mit Lesezeit und Schlüsselwortdichte. Funktioniert bei der Eingabe.`)
};

const nl_wc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis woord- en karakterteller. Tel woorden, tekens, zinnen en alinea's, met leestijd en trefwoorddichtheid. Werkt terwijl u typt.`)
};

const fr_wc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compteur de mots et caractères gratuit. Comptez les mots, les caractères, les phrases et les paragraphes, avec le temps de lecture et la densité des mots-clés. Fonctionne en temps réel.`)
};

const it_wc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatore di parole e caratteri gratuito. Conta parole, caratteri, frasi e paragrafi, con tempo di lettura e densità di parole chiave. Funziona mentre digiti.`)
};

const pt_br2_wc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de palavras e caracteres gratuito. Conte palavras, caracteres, frases e parágrafos, com tempo de leitura e densidade de palavras-chave. Funciona enquanto você digita.`)
};

const pt_wc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de palavras e caracteres grátis. Conte palavras, caracteres, frases e parágrafos, com tempo de leitura e densidade de palavras-chave. Funciona conforme escreve.`)
};

const ja_wc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の単語・文字カウンター。単語、文字、文、段落をカウント。読む時間とキーワード密度も表示。入力中にリアルタイムで更新されます。`)
};

const zh_wc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的字数与字符计数器。统计字数、字符数、句子数和段落数，并提供阅读时间和关键词密度。输入即可实时统计。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_tool_description", locale)
	if (locale === "en") return en_wc_tool_description(inputs)
	if (locale === "es") return es_wc_tool_description(inputs)
	if (locale === "de") return de_wc_tool_description(inputs)
	if (locale === "nl") return nl_wc_tool_description(inputs)
	if (locale === "fr") return fr_wc_tool_description(inputs)
	if (locale === "it") return it_wc_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_wc_tool_description(inputs)
	if (locale === "pt") return pt_wc_tool_description(inputs)
	if (locale === "ja") return ja_wc_tool_description(inputs)
	return zh_wc_tool_description(inputs)
};